import Keycloak from "keycloak-js";

function resolveRealmFromHost() {
  if (typeof window === "undefined") {
    return "e-invoicing-prod";
  }

  const host = (window.location.hostname || "").toLowerCase();

  if (host === "localhost" || host === "127.0.0.1") {
    return "e-invoicing-dev";
  }

  if (host.startsWith("dev.")) {
    return "e-invoicing-dev";
  }

  if (host.startsWith("test.")) {
    return "e-invoicing-test";
  }

  if (host.startsWith("prod.")) {
    return "e-invoicing-prod";
  }

  return "e-invoicing-prod";
}

const keycloak = new Keycloak({
  url: typeof window !== "undefined" && ["test.invoice.nerdforce.works", "invoice.nerdforce.works"].includes(window.location.hostname.toLowerCase())
    ? "https://auth.nerdforce.works"
    : process.env.VUE_APP_KEYCLOAK_BASE_URL,
  realm: resolveRealmFromHost(),
  clientId: "e-invoice-frontend",
});

export default keycloak;
